 <!-- <button (click)="openll()" mat-icon-button><mat-icon>keyboard_arrow_down</mat-icon></button>
<button (click)="closell()" mat-icon-button ><mat-icon>keyboard_arrow_up</mat-icon></button>  -->

<!-- <mat-accordion class="example-headers-align questionblock" multi="true" #accordion="matAccordion">
   
  <ng-container *ngFor="let block of queryBlocks; let i = index" > 
  <mat-expansion-panel [expanded]="openpanel === i">
      <mat-expansion-panel-header >
        <div class="question" (click)="$event.stopPropagation();" (keydown)="$event.stopPropagation();">
         <input class="" type="text"  [(ngModel)]="block.title" placeholder="Title">
         <mat-icon (click)="openQuestionPanel(updateQuestion,block,i)">edit</mat-icon>
         <button class="btn btn-success runAI" (click)="query_vector_db(i,block)" >Run AI</button>
         <button mat-stroked-button (click)="addFileAIPrompts(i,block)" >Save</button>
         <button mat-icon-button (click)="deleteQuery(block,i)">
          <mat-icon>close</mat-icon>
         </button>
        </div>
      </mat-expansion-panel-header>
  
       <textarea [(ngModel)]="block.apiResponseTextArea" placeholder="Answer will be here......"
      class="response-textarea"></textarea>

      
      

    </mat-expansion-panel>
  </ng-container>
  </mat-accordion> -->

  <!-- <div [innerHTML]="contect"></div> -->

  <div class="allAnswers" cdkDropList (cdkDropListDropped)="drop($event)">
    <mat-accordion>
      <ng-container *ngFor="let block of queryBlocks; let i = index">
        <!-- [expanded]="step === i" -->
        <mat-expansion-panel  disabled="false" (click)="togglePanels(i)"
         cdkDrag>
          <mat-expansion-panel-header cdkDragHandle>
            <mat-icon>drag_indicator</mat-icon>
            <mat-panel-title>{{ block.title }}</mat-panel-title>
          </mat-expansion-panel-header>
  
          <div class="blockAction" style="display: flex;">
            <button (click)="openQuestionPanel(updateQuestion, block, i)">Edit Question</button>
            <button (click)="runAIButton_4o_Run(i, block)">Run AI</button>
            <button (click)="deleteQuery(block, i)">Delete</button>
            <button (click)="toggleEdit(block,$event)" *ngIf="!block.isEditing">
              Edit Response
            </button>
            <button (click)="saveText(block, block.apiResponseTextArea)" *ngIf="block.isEditing">
              Save
            </button>
            <button (click)="saveTextToCore(block.apiResponseTextArea)" *ngIf="transactionID>0 && block.isMedication==true; else attachSpan">
              Send To {{CoreShowName}} Profile
            </button>
            <ng-template #attachSpan>
             <div style="background: #e3abbe;" *ngIf="block.isMedication==true" class="alert alert-warning" role="alert">
             ⚠️ <strong>Action Required:</strong> Connect {{CoreShowName}} to send medication
             </div>
            </ng-template>
            <!-- <button (click)="chooseResponse(ChooseResponse,block, i)">Choose Response</button> -->
          </div>
  
          <!-- <p [innerHTML]="block.apiResponseTextAreaNew"></p> -->

          <ng-container *ngIf="!block.isEditing">
            <p [innerHTML]="getLinkedText(block.apiResponseTextAreaNew)" (click)="handleLinkClick($event)"></p>
          </ng-container>

          <ng-container *ngIf="block.isEditing">
            <textarea style="width:100%; padding:10px"
              [(ngModel)]="block.apiResponseTextArea"
              (input)="adjustHeight($event.target)"
              [id]="'txtarea' + block.nlpTemplateID"
            ></textarea>
          </ng-container>
        </mat-expansion-panel>
      </ng-container>
    </mat-accordion>
  </div>

  
 


  <ng-template #updateQuestion>
    <form  [formGroup]="formDialog">
    <h2 mat-dialog-title>
      <span class="groupIcon">
        <mat-icon>view_column</mat-icon>
      </span>
      Update Question
  
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
      
    </h2>
  
   <mat-dialog-content class="mat-typography">
  
   <div class="allheaders">
   
    <mat-form-field class="example-half-width">                
      <mat-label>Title</mat-label>
       <input matInput placeholder="Add Title" formControlName="title" >
       <!-- <mat-error
        *ngIf="formDialog.get('title').invalid &&
          (formDialog.get('title').dirty ||
          formDialog.get('title').touched)">
        <span>This field is mandatory.</span>
      </mat-error> -->
     </mat-form-field> 
     <mat-expansion-panel style="margin-bottom: 11px;" class="questionTitle"  [expanded]="true"  disabled="false">
      <mat-expansion-panel-header>
        <mat-panel-title>Use Response from Prior Questions</mat-panel-title>
      </mat-expansion-panel-header>
     
      <div class="d-flex">
        <div *ngFor="let block of queryBlocks; let i = index" class="mr-10">
          <div class="checkbox-container" *ngIf="nlpTemplateID!=block.nlpTemplateID">
            <mat-checkbox
              [checked]="(currentBlockToEdit.choosenPromptID || '').split(',').includes(block.nlpTemplateID?.toString())"
              (change)="OnChangeChooseAnswer($event, block, i)">
              {{ block.title }}
            </mat-checkbox>
          </div>
        </div>
      </div>
      
      

    </mat-expansion-panel>

    <div class="checkbox-container">
      <mat-checkbox formControlName="isNta" style="float: right;">
        Use NTA
      </mat-checkbox>
      <mat-checkbox formControlName="isMedication" style="float: right; margin-right: 15px;">
        Use Medication
      </mat-checkbox>
    </div>
    
    <div *ngIf="ddlsystemPromptID!=undefined && sysPromptList?.length > 0">
      <mat-form-field class="example-half-width">
        <mat-label>Predefined Models</mat-label>
        <mat-select [(value)]="ddlsystemPromptID" (selectionChange)="selectSysPrompt($event)">
          <mat-option value="0">-Select Predefined Models-</mat-option>
          <mat-option *ngFor="let type of sysPromptList; trackBy: trackByFn" [value]="type.systemPromptID">
            {{ type.systemPromptTitle }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

     <mat-form-field class="example-half-width">                
      <mat-label>Question</mat-label>
       <textarea  style="height: 270px;" matInput placeholder="Type your question here if you are not using predefined model above" rows="5" cols="40" formControlName="prompt">        
       </textarea>        
     </mat-form-field>     

    
   </div>
  
    </mat-dialog-content>
  
    <mat-dialog-actions>
      <button mat-button (click)="close()">Cancel</button>
      <div class="">
        <!-- <button mat-stroked-button color="primary" (click)="SendDocumentTo_4o(formDialog.value)">Run AI</button> -->
      <button mat-flat-button color="primary" [disabled]="formDialog.invalid || !formDialog.dirty"   
        (click)="updateQuestions(formDialog.value)">
        Update
      </button>
      </div>
    </mat-dialog-actions>
  </form>
  </ng-template>

  <ng-template #ChooseResponse>
    <form  [formGroup]="formDialog">
    <h2 mat-dialog-title>
      <span class="groupIcon">
        <mat-icon>view_column</mat-icon>
      </span>
      Update Question
  
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
      
    </h2>
  
   <mat-dialog-content class="mat-typography">
    
   <div *ngFor="let block of queryBlocks; let i = index">
      
    <div class="checkbox-container">
      <mat-checkbox (change)="OnChangeChooseAnswer($event,block,i)">
        {{block.title}}
      </mat-checkbox>
    </div>
   </div>
  
    </mat-dialog-content>
  
    <mat-dialog-actions>
      <button mat-button (click)="close()">Cancel</button>
      <div class="">
        <button mat-flat-button color="primary"  
        (click)="close()">
        Update
      </button>
      </div>
    </mat-dialog-actions>
  </form>
  </ng-template>